import React from "react";
import { Link } from "react-router-dom";

const AnalyticsHeader = ({ event, backTo }) => {
  const hasBannerImage = Boolean(event.banner_image_url);
  const eventMeta = [
    event.venue_name,
    event.city_state,
    [event.start_date, event.end_date].filter(Boolean).join(" - "),
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <div className="event-analytics-preview__header-block">
      <Link className="event-analytics-preview__back-link" to={backTo}>
        ← Events
      </Link>

      <header className="event-analytics-preview__header">
        <div
          className={`event-analytics-preview__header-layout ${
            hasBannerImage ? "event-analytics-preview__header-layout--with-image" : ""
          }`}
        >
          <div className="event-analytics-preview__header-copy">
            <div className="event-analytics-preview__eyebrow-row">
              <span
                className={`event-analytics-preview__status-pill ${
                  event.is_upcoming
                    ? "event-analytics-preview__status-pill--upcoming"
                    : "event-analytics-preview__status-pill--past"
                }`}
              >
                {event.is_upcoming ? "Upcoming event" : "Past event"}
              </span>

              <p className="event-analytics-preview__eyebrow">
                Event Analytics: Current Performance Snapshot
              </p>
            </div>

            <h1 className="event-analytics-preview__title">{event.name}</h1>

            {eventMeta && <p className="event-analytics-preview__meta">{eventMeta}</p>}
          </div>

          {hasBannerImage && (
            <div className="event-analytics-preview__header-image-shell">
              <img
                alt={`${event.name} banner`}
                className="event-analytics-preview__header-image"
                src={event.banner_image_url}
              />
            </div>
          )}
        </div>
      </header>
    </div>
  );
};

export default AnalyticsHeader;
